import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';

import { Grid } from '@mui/material';
import Dashboard from 'layouts/V2/Dashboard';
import PropTypes from 'prop-types';

import styles from '../Guesty/guesty.module.css';

import ConfigureBrand from '../Guesty/components/ConfigureBrand';
import EditDefaultBrand from '../Guesty/components/EditDefaultBrand';
import HostawayPage from './HostawayPage';

function HostawayHome(props) {
    return (
        <Grid>
            <Switch>
                <Route
                    path={`${props.match.path}`}
                    render={() => <HostawayPage {...props} integrationName="hostaway" />}
                    exact
                />
                <Route
                    path={`${props.match.path}/brands/:uuid/edit`}
                    render={() => (
                        <Dashboard mainContainerStyles={styles.editBrandWrapper}>
                            <EditDefaultBrand {...props} integrationName="hostaway" />{' '}
                        </Dashboard>
                    )}
                    exact
                />
                <Route
                    path={`${props.match.path}/brands/:uuid`}
                    render={() => <ConfigureBrand {...props} integrationName="hostaway" />}
                    exact
                />
            </Switch>
        </Grid>
    );
}

HostawayHome.propTypes = {
    match: PropTypes.object,
};

export default withRouter(HostawayHome);
